import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

interface RegenerateSectionResponse {
  ok: boolean;
  section_key: string;
  workflow_id?: string;
}

/**
 * useRegenerateSection — marks a section stale and (for completed briefs)
 * starts `refreshBriefStaleWorkflow` for that key. Cache is invalidated;
 * `useBrief` polls while stale flags remain.
 */
export function useRegenerateSection(briefId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ section_key }: { section_key: string }) =>
      apiPost<RegenerateSectionResponse>(`/v1/briefs/${briefId}/regenerate-section`, {
        section_key,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['brief', briefId] });
      void qc.invalidateQueries({ queryKey: ['briefs'] });
    },
  });
}
